<template>
    <div :class="classe + ' box-show'">
        <div class="graficos">
            <line-chart class="wrapper" :chartData="chartData"></line-chart>
        </div>
    </div>
</template>

<script>
    import LineChart from '../../chats/barChart';

    export default {
        name: "c-grafico",
        components: {
            'line-chart': LineChart
        },
        props: {
            classe: String,
            chartData: Object
        },
    }

</script>